import { m } from 'framer-motion';
import React, { forwardRef } from 'react';
// @mui
import Box from '@mui/material/Box';
import Link, { LinkProps } from '@mui/material/Link';
import CardActionArea from '@mui/material/CardActionArea';
// routes
import { RouterLink } from 'src/routes/components';
// components
import Iconify from 'src/components/iconify';
//
import { Menu, MenuItem } from '@mui/material';
import { useLocales } from 'src/locales';
import { NavItemDesktopProps, NavItemProps } from '../types';
import { ListItem } from './styles';

// ----------------------------------------------------------------------

export const NavItem = forwardRef<HTMLDivElement, NavItemDesktopProps>(
  ({ item, open, offsetTop, active, subItem, externalLink, ...other }, ref) => {
    const { title, path, icon, showIcon, showTitle } = item;
    const { t } = useLocales();
    const renderContent = (
      <ListItem
        ref={ref}
        disableRipple
        offsetTop={offsetTop}
        subItem={subItem}
        // active={active}
        open={open}
        {...other}
      >
        {showIcon.onDesktop && icon}
        {showTitle.onDesktop && t(title)}
        {!!item.children && (
          <Iconify width={16} icon="eva:arrow-ios-downward-fill" sx={{ ml: 1, flexShrink: 0 }} />
        )}
      </ListItem>
    );
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    // External link
    if (externalLink) {
      return (
        <Link href={path} target="_blank" rel="noopener" underline="none">
          {renderContent}
        </Link>
      );
    }

    // Default
    return (
      <Link href={path} underline="none">
        {renderContent}
      </Link>
    );
  }
);

// ----------------------------------------------------------------------
